import styled from 'styled-components'

export const List = styled.ul`
  display: block;
  margin: 0 auto;
`


// WEBPACK FOOTER //
// ./src/components/PostList/styles.js